module.exports = __webpack_public_path__ + "static/services-d1f7a185db8bc9f375ddc990520576aa.jpg";